<template>
  <el-dialog
    :title="isSingle ? '筛选器' : '添加筛选'"
    :visible.sync="visible"
    class="dialog-content"
    :width="isSingle ? '760px' : '880px'"
    :before-close="closeHandle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
  >
    <div class="field-filter">
      <div class="title">
        <span v-if="isSingle">{{ filterUnitGroupName }}</span>
        <span v-else>同时添加多组条件，多组条件的关系为同时满足</span>
      </div>
      <div class="form-content">
        <div class="add-field-btn" v-if="currentFilterArr.length < 1">
          <el-button class="add-btn" type="text" @click="addFilterHandle">
            <i class="iconfont iconjia"></i>
            <span>添加筛选标签</span>
          </el-button>
        </div>
        <div class="group-type-content" v-if="!isSingle && currentFilterArr.length > 1">
          <span class="group-text" v-if="groupType === 'and'" @click="checkoutGroupType('or')">且</span>
          <span class="group-text" v-if="groupType === 'or'" @click="checkoutGroupType('and')">或</span>
        </div>
        <div
          class="form-li"
          :class="isSingle ? 'is-single' : ''"
          v-for="(filterItem, filterIndex) in currentFilterArr"
          :key="filterItem.uniqueId"
        >
          <el-select v-if="isSingle" class="field-select-item" disabled v-model="filterItem.columnKey">
            <el-option :value="filterItem.columnKey" :label="filterItem.columnInfo.title"></el-option>
          </el-select>
          <el-select
            v-else
            class="field-select-item"
            v-model="filterItem.columnKey"
            filterable
            placeholder="请选择标签"
            @change="id => changeColumnHandle(id, filterIndex)"
          >
            <el-option
              v-for="columnItem in allColumns"
              :key="columnItem.columnKey"
              :value="columnItem.columnKey"
              :label="columnItem.title"
            />
          </el-select>

          <component
            v-if="filterItem.columnInfo"
            ref="filterRefs"
            :is="`${filterItem.columnInfo.type}Filter`"
            :key="`${filterItem.columnKey}_${filterItem.uniqueId}`"
            :uniqueId="filterItem.uniqueId"
            :courseId="courseId"
            :currentColumn="filterItem.columnInfo"
            :defaultFormData="filterItem.defaultFormData"
            @change="() => refreshCompHandle(filterItem.uniqueId)"
          />

          <div class="tool-btns" v-if="!isSingle">
            <div class="tool-btn add" @click="addFilterHandle">
              <i class="el-icon-circle-plus-outline"></i>
            </div>
            <div class="tool-btn sub" @click="currentFilterArr.splice(filterIndex, 1)">
              <i class="el-icon-remove-outline"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="field-select-tips" v-if="!isSingle">
        <span
          >筛选的标签来自当前统计图表已添加的标签。如需更多筛选标签，请在统计图表页面，点击左上角“添加标签”按钮即可添加筛选需要的标签。</span
        >
      </div>
    </div>
    <span slot="footer">
      <el-button @click="closeHandle">取 消</el-button>
      <el-button type="primary" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';

import textFilter from './components/textFilter';
import dateFilter from './components/dateFilter';
import numFilter from './components/numFilter';
import { uniqueId } from 'lodash';

export default {
  components: { textFilter, dateFilter, numFilter },
  data() {
    return {
      groupType: 'and',
      currentFilterArr: [],
      isSingle: false,
      preGroupType: ''
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    allColumns: {
      type: Array,
      default: () => []
    },
    courseId: {
      type: String,
      default: ''
    },
    filterItem: {
      type: Object,
      default: () => null
    },
    courseFilterArr: {
      type: Array,
      default: () => []
    },
    filterArr: {
      type: Array,
      default: () => []
    },
    filterUnitGroupName: {
      type: String,
      default: ''
    }
  },
  provide() {
    return {
      getQueryBody: id => {
        if (this.groupType === 'or') {
          return { query: [...this.courseFilterArr, ...this.filterArr] };
        }

        const curFilterArr = [];

        this.currentFilterArr.forEach((filterItem, filterIndex) => {
          if (!filterItem.columnInfo || filterItem.uniqueId === id) {
            return;
          }
          let formData = null;
          try {
            const comEl = this.$refs.filterRefs && this.$refs.filterRefs[filterIndex];
            if (comEl) {
              formData = comEl.validateInfo();
            }
          } catch (err) {
            // console.error(err);
          }
          if (formData) {
            curFilterArr.push({ columnInfo: filterItem.columnInfo, formData });
          }
        });

        const queryBody = {
          query: [
            ...this.courseFilterArr,
            ...this.filterArr,
            {
              fieldType: 'group',
              op_type: this.groupType,
              fieldArr: curFilterArr
            }
          ]
        };

        const filterInfoBySession = JSON.parse(sessionStorage.getItem('DATA_CLEANER_FILTER_INFO') || '{}');
        if (filterInfoBySession.collectShow) {
          queryBody.isCollect = true;
          if (filterInfoBySession.collectGroup) {
            queryBody.groupId = filterInfoBySession.collectGroup;
          }
        }
        if (filterInfoBySession.resetDelShow) {
          queryBody.searchDelete = true;
        }

        return queryBody;
      }
    };
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  created() {
    const currentFilterArr = [];
    let fieldArr = [];
    if (this.filterItem) {
      if (this.filterItem.fieldType === 'group') {
        fieldArr = [...this.filterItem.fieldArr];
        this.groupType = this.fieldItem.op_type;
      } else {
        this.isSingle = true;
        fieldArr = [this.filterItem];
      }
    }
    fieldArr.forEach(fieldItem => {
      currentFilterArr.push({
        uniqueId: this.fetchUniqueId(),
        columnKey: fieldItem.columnInfo.columnKey,
        columnInfo: fieldItem.columnInfo,
        defaultFormData: fieldItem.formData ? cloneDeep(fieldItem.formData) : null
      });
    });
    this.currentFilterArr = currentFilterArr;
  },
  methods: {
    checkoutGroupType(type) {
      this.groupType = type;
      this.refreshCompHandle();
    },
    refreshCompHandle(uniqueId = '') {
      if (this.preGroupType === this.groupType && this.preGroupType === 'or') {
        return;
      }
      this.preGroupType = this.groupType;
      this.$refs.filterRefs.forEach(filterEl => {
        if (filterEl.$options.propsData.uniqueId !== uniqueId && filterEl.refreshHandle) {
          filterEl.refreshHandle();
        }
      });
    },
    fetchUniqueId() {
      return uniqueId('field_filter_temp_');
    },
    changeColumnHandle(id, filterIndex) {
      const columnInfo = this.allColumns.find(item => item.columnKey === id);
      this.currentFilterArr.splice(filterIndex, 1, {
        ...this.currentFilterArr[filterIndex],
        formData: null,
        columnInfo
      });
    },
    addFilterHandle() {
      this.currentFilterArr.push({
        uniqueId: this.fetchUniqueId(),
        columnKey: '',
        columnInfo: null,
        defaultFormData: null
      });
    },
    confirmHandle() {
      try {
        const effCurrentFilterArr = this.currentFilterArr.filter(filterItem => !!filterItem.columnInfo);
        if (Object.keys(effCurrentFilterArr).length < 1) {
          throw new Error('请添加有效的标签后确认');
        }
        const filterArr = effCurrentFilterArr.map((filterItem, filterIndex) => {
          const formData = this.$refs.filterRefs[filterIndex].validateInfo();
          return { columnInfo: filterItem.columnInfo, formData };
        });
        if (this.isSingle) {
          this.$emit('confirm', filterArr[0]);
        } else {
          this.$emit('confirm', {
            fieldType: 'group',
            op_type: this.groupType,
            fieldArr: filterArr
          });
        }
        this.closeHandle();
      } catch (err) {
        this.$message.warning(err.message);
      }
    },
    closeHandle() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-content {
  ::v-deep .el-dialog__footer {
    border-top: 1px solid #d2d8e3;
  }
}
.field-filter {
  box-sizing: border-box;
  max-height: $dialogBodyMaxHeight;

  .title {
    font-size: 14px;
    color: #3d465a;
    padding: 10px 20px;
  }

  .field-select-tips {
    font-size: 12px;
    color: #a0acc0;
    margin-left: 40px;
  }

  .form-content {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    margin-top: 10px;
    padding: 0 20px 20px;
    max-height: 300px;
    overflow: auto;

    .add-field-btn {
      .add-btn {
        font-weight: bold;
        font-size: 14px;
        .iconfont {
          font-size: 14px;
          margin-right: 2px;
        }
      }
    }

    .group-type-content {
      position: absolute;
      left: 15px;
      font-size: 12px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;

      .group-text {
        color: #1991fb;
        background-color: #eaf6ff;
        cursor: pointer;
      }
    }

    .form-li {
      box-sizing: border-box;
      position: relative;
      min-height: 42px;
      overflow: hidden;
      padding: 5px 80px 5px 20px;
      display: flex;
      align-items: flex-start;

      .field-select-item {
        width: 160px;
        margin-right: 5px;
      }

      .tool-btns {
        position: absolute;
        right: 10px;
        top: 10px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;

        .tool-btn {
          font-size: 16px;
          padding: 2px;
          cursor: pointer;
          margin-left: 5px;

          &.add {
            color: #1991fb;
          }

          &.sub {
            color: #a0acc0;
          }
        }
      }

      &::before {
        content: ' ';
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        height: 100%;
        background-color: #d9dde4;
      }

      &.is-single {
        padding: 0;
        &::before {
          display: none;
        }
      }
    }
  }
}
</style>
